var map = {
	"./0.svg": 188,
	"./1.svg": 279,
	"./10.svg": 280,
	"./11.svg": 281,
	"./12.svg": 282,
	"./2.svg": 283,
	"./3.svg": 284,
	"./4.svg": 285,
	"./5.svg": 286,
	"./6.svg": 287,
	"./7.svg": 288,
	"./8.svg": 289,
	"./9.svg": 290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 332;